import { Injectable } from '@angular/core';
import { BaseDataSourceServiceV2, PageableListV2Dto, SnackbarService } from '@fleet-beat/core';
import { DataAutocompleteStorageParams } from '@fleet-beat/editor';
import { AuthService } from '@fleet-beat/shared';
import { WebhookEventTypeDto, WebhooksApiService } from '@fleet-beat/api';
import { map, Observable } from 'rxjs';

export interface EventTypeOption {
  value?: string;
  label?: string;
}

@Injectable({
  providedIn: 'root',
})
export class EventTypeListAutocompleteStorageService extends BaseDataSourceServiceV2<
  EventTypeOption,
  DataAutocompleteStorageParams<object>
> {
  constructor(
    protected override snackbarService: SnackbarService,
    private authService: AuthService,
    private webhooksApiService: WebhooksApiService,
  ) {
    super(snackbarService);
  }

  protected override getData(
    data: DataAutocompleteStorageParams<{ input: string }>,
  ): Observable<PageableListV2Dto<EventTypeOption>> {
    const { input } = (data.params as any) || {};
    const search: string = input && input.trim() !== '' ? input.trim().toLowerCase() : '';

    return this.webhooksApiService.getEventTypesAsAdmin(this.authService.authHeaders).pipe(
      map((eventTypes: WebhookEventTypeDto[]) => {
        const filtered: WebhookEventTypeDto[] = search
          ? eventTypes.filter((type: WebhookEventTypeDto) => type.name.toLowerCase().includes(search))
          : eventTypes;
        const options: EventTypeOption[] = filtered.map((type: WebhookEventTypeDto) => ({
          value: type.name,
          label: this.humanize(type.name),
        }));

        return {
          data: options,
          currentPage: 1,
          from: options.length ? 1 : 0,
          lastPage: 1,
          perPage: options.length,
          to: options.length,
          total: options.length,
        };
      }),
    );
  }

  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  protected override getById(id: string): Observable<EventTypeOption> {
    throw new Error('Not Implemented');
  }

  private humanize(value: string): string {
  if (!value) {
    return '';
  }
  const withoutPrefix: string[] = value.split('.').slice(1);
  const segments: string[] = withoutPrefix.length ? withoutPrefix : value.split('.');
  const words: string[] = segments.join(' ').split(/[._\s]+/).filter(Boolean);

  return words.map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}
}
